module.exports = __webpack_public_path__ + "assets/img/high-severity.3b4fac7f.png";